import { DefaultHierarchyLevelType } from '@wppopen/core'
import { OsContextValue } from '@wppopen/react'
import appContext from 'context/appContext'
import { useContext, useMemo } from 'react'
import { PDP_GENERATOR_API_HEADERS } from 'utils/constants'

interface useOsContextProps {
  wppOpenOsContextOverride?: OsContextValue | null
}

const useOsContext = ({ wppOpenOsContextOverride }: useOsContextProps) => {
  const { osContextValue: osContextValueFromAppContext } = useContext(appContext)
  const osContextValue = wppOpenOsContextOverride || osContextValueFromAppContext

  const tenantId = useMemo(() => {
    const hierarchy = osContextValue?.osContext?.hierarchy
    if (!hierarchy) return null
    const tenantHierarchyObj = Object.values(hierarchy.mapping).find(({ type }) => {
      return type === DefaultHierarchyLevelType.Tenant
    })
    if (!tenantHierarchyObj) return null

    return tenantHierarchyObj.azId
  }, [osContextValue?.osContext?.hierarchy])

  const client_ids: string[] = [
    // Add client ids here if necessary
  ]

  const account_ids: HeadersInit = {
    [PDP_GENERATOR_API_HEADERS.WPP_OPEN_WORKSPACE_ID_HEADER]: tenantId || '',
  }

  if (!tenantId) delete account_ids[PDP_GENERATOR_API_HEADERS.WPP_OPEN_WORKSPACE_ID_HEADER]

  const bearerHeader: HeadersInit = {
    Authorization: `Bearer ${osContextValue?.osApi?.getAccessToken()}`,
  }

  return { tenantId, client_ids, account_ids, bearerHeader }
}

export default useOsContext
